import { ISelectData } from 'components/atoms/SelectComponent';

import { EProxyTypeEnums } from 'enums/akcionarKorpAkce/proxyTypeEnums';

export const proxyTypeSelect: ISelectData[] = [
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_CHRM',
        value: EProxyTypeEnums.CHRM
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_DISC',
        value: EProxyTypeEnums.DISC
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_NEPR',
        value: EProxyTypeEnums.NEPR
    },
    {
        labelcz: 'SRD_PRUVODCE_VH_D_PRIDAT_HLDR',
        value: EProxyTypeEnums.HLDR
    }
];
